/**
 * TagRegisterContainer
 * --
 */
import React from 'react';
import TagRegisterPresenter from './TagRegisterPresenter';

const TagRegisterContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <TagRegisterPresenter />
    </>
  );
};

export default TagRegisterContainer;
